<template>
    <div type="table" class="input aggregationTable"  :class="input.extraClass">
        <div class="input search">
            <label>
                <input type="search" :placeholder="input.searchPlaceholder" v-on:keyup="searchTable($event)" v-on:blur="searchTable($event)" />
            </label>
        </div>
        <div class="studies" ref="tables">
            <div v-for="table in getTables">
                <header>{{ table.name }} › {{ table.versionName }}</header>
                <table>
                    <thead>
                        <tr>
                            <td> </td>
                            <td v-for="col in input.forms">{{ col.name }}</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                                v-for="row in getRows(input, table)"
                                v-on:click="onStudyRowClick(row, input, table)">
                            <td>
                              
                              <input type="checkbox" :disabled="isDisabled()" :value="row.id" v-model="formValue.selectedRows">
                            </td>
                            <td v-for="td in input.forms">
                                <template v-if="typeof td.value === 'string'">
                                    {{ getNestedValue(row, td.value) }}
                                </template>
                                <template v-else>
                                    {{ td.value(table.data, row) }}
                                </template>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

</template>

<script>
    import InputField from "./InputField.vue"
    import HelperBox from "../HelperBox.vue"

    export default {
        components: {
            InputField,
            HelperBox
        },
        name: "AggregationTable",
        props: {
            input: {
                type: Object,
                required: true
            },
            formValue: {
                type: Object,
                required: false
            }
        },
        mounted () {
            if(!this.formValue.selectedRows)
                this.formValue.selectedRows = []
        },
        computed: {
            getTables() {
                if(!this.formValue || !this.input.value)
                    return [];

                let list = [];

                for(let id of this.getNestedValue(this.formValue, this.input.value)){
                    let study = this.$store.state.editor.version.data.studies.find(x => x.id === id);
                    let item = {
                        name: study.name,
                        studyId: study.id,
                        versionName: study.versionName,
                        forecastVersionId: study.forecastVersionId,
                        data: this.$store.getters.forecastVersion(study.forecastVersionId).data
                    };
                    list.push(item)
                }

                return list;
            },
        },
        methods: {
            searchTable(e){
                let q = e.target.value.toLowerCase();

                this.$refs.tables.querySelectorAll("tbody tr").forEach((row) => {
                    if(row.innerText.toLowerCase().indexOf(q) === -1)
                        row.classList.add("hide");
                    else 
                        row.classList.remove("hide");
                });
            },
            getRows(input, table){
                let sortValue = input.forms[0].value;
                let rows = (typeof input.rows === 'string' ? table.data[input.rows] : input.rows(table, this.formValue));
                return rows.sort((a, b) => a[sortValue].localeCompare(b[sortValue]));
            },
            onStudyRowClick(row, input, table){

                if(this.formValue.selectedRows.indexOf(row.id) === -1)
                    this.formValue.selectedRows.push(row.id);
                else
                    this.formValue.selectedRows.splice(this.formValue.selectedRows.indexOf(row.id), 1);

                //this.buildSelectedAggregations(row, input, table);
                this.rebuildSelectedList(input, table);

                if(input.callback)
                    input.callback(this.formValue, this.getTables);

                // If new list, checkboxes are not visual checked. So force update render
                this.$nextTick(() => {
                    this.$forceUpdate();
                });
            },
            isDisabled() {
              // First check if has Disabled prop
              if (this.input.disabled) return true;
              let processStatus = this.$store.state.editor.version.processStatus;
              return processStatus === 2 || processStatus === 3;
            },
            buildSelectedAggregations(row, input, table){
                let array = this.formValue[input.valueGroup];
                if(!array)
                    array = this.formValue[input.valueGroup] = [];

                let newItem = {
                    id: row.id,
                    study: {
                        name: table.name,
                        id: table.forecastVersionId, // This is "study id" in final main Study.json file
                        studyId: table.studyId
                    }
                };

                for(let form of input.forms){
                    if(!form.valueId)
                        continue;

                    if(!newItem[form.valueGroup]){
                        newItem[form.valueGroup] = {};
                    }

                    if(typeof form.value === 'string')
                    {
                        newItem[form.valueGroup].name = this.getNestedValue(row, form.value);
                        newItem[form.valueGroup].id = this.getNestedValue(row, form.valueId);
                    }
                    else
                    {
                        newItem[form.valueGroup].name = form.value(table.data, row);
                        newItem[form.valueGroup].id = form.valueId(table.data, row);
                    }
                }

                array.push(newItem);
            },
            rebuildSelectedList(input){
                // Rebuild all selected rows based on tables (studies)

                this.formValue[input.valueGroup] = [];

                for(let table of this.getTables){
                    let rows = this.getRows(input, table);
                    for(let row of this.formValue.selectedRows){
                        let rowItem = rows.find(x => x.id === row);
                        if(!rowItem)
                        {
                            continue;
                        }

                        this.buildSelectedAggregations(rowItem, input, table);
                    }
                }
            }
        }
    }
</script>